import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import {
  H1,
  H3,
  H6,
  YekanParagraph,
  VazirParagraph,
} from "../components/typography"
import { BaseContainer } from "../components/container"

const Terms = ({ data }) => {
  const { title, description, contact } = data.contentYaml.content
  return (
    <Layout>
      <SEO slug="/report" />
      <BaseContainer direction="vertical">
        <H1>{title}</H1>
        <YekanParagraph>{description}</YekanParagraph>
        {contact.map((a, i) => (
          <div
            style={{ marginTop: "10px" }}
            key={`${a.type.split(" ")[0]}_${i}`}
          >
            <VazirParagraph
              dangerouslySetInnerHTML={{ __html: ` - ${a.type}` }}
            />
          </div>
        ))}
      </BaseContainer>
    </Layout>
  )
}

export const query = graphql`
  {
    contentYaml(header: { slug: { eq: "/report" } }) {
      content {
        title
        description
        contact {
          type
        }
      }
    }
  }
`

export default Terms
